import React from 'react';
import { Link } from 'react-router-dom';
type BrandProps = {
  tone?: 'dark' | 'light';
};
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/sfio5nMTtdMQFgmLKeBBxC/Logo_(1)_1.png';

/**
 * WebsiteForge lockup using the real logo file.
 */
export function Brand({
  tone = 'dark'
}: BrandProps) {
  return <Link to="/" className="group flex items-center gap-3" aria-label="WebsiteForge — home" data-id="element-301" data-mp="g6nvuow6ol4o">
      <img src={LOGO_URL} alt="WebsiteForge" className="h-9 w-auto sm:h-10" data-id="element-302" data-mp="1cwf0vi23pqoq" />
      <span className={`hidden border-l pl-3 font-mono text-[10.5px] uppercase leading-tight tracking-[0.18em] sm:block ${tone === 'dark' ? 'border-white/15 text-mist-400' : 'border-navy-900/15 text-navy-600'}`} data-id="element-303" data-mp="18utf177la22e">
        Custom built
        <br data-id="element-304" data-mp="yygky884tm74" />
        since 2002
      </span>
    </Link>;
}